// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QGF_","actions":"styles_actions__34TPd","error":"styles_error__29qLX","message":"styles_message__3WqPK"};